// LoadingInterior.jsx
import React from 'react';
import { motion } from 'framer-motion';

const LoadingInterior = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        background: '#111',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '40px',
        zIndex: 9999
      }}
    >
      <motion.div
        animate={{
          scale: [0.9, 1, 0.9],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}
      >
        <motion.svg 
          width="60" 
          height="60" 
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          strokeWidth="2"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </motion.svg>
        
        <motion.h2 
          style={{ 
            color: '#fff',
            fontFamily: 'var(--font-poppins)',
            fontSize: '24px',
            letterSpacing: '4px'
          }}
        >
          DHIMAN WOOD WORKS
        </motion.h2>
      </motion.div>

      <motion.div
        style={{
          display: 'flex',
          gap: '8px'
        }}
      >
        {['C', 'R', 'A', 'F', 'T', 'I', 'N', 'G'].map((letter, index) => (
          <motion.span
            key={index}
            animate={{
              opacity: [0.3, 1, 0.3],
              y: [0, -8, 0]
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              delay: index * 0.1,
              ease: "easeInOut"
            }}
            style={{
              color: '#fff',
              fontSize: '12px',
              letterSpacing: '2px'
            }}
          >
            {letter}
          </motion.span>
        ))}
      </motion.div>
    </motion.div>
  );
};

export default LoadingInterior;
